<template>
  <header class="omx-top">
    <button class="omx-top__burger" @click="$emit('open-mobile')" :aria-label="$t('shell.open-menu')">
      <b-icon icon="menu" />
    </button>

    <OmxBreadcrumbs class="omx-top__crumbs" />

    <button class="omx-top__cmd" @click="$emit('open-command')" :aria-label="$t('shell.command.placeholder')">
      <b-icon icon="magnify" size="is-small" />
      <span class="omx-top__cmd-text">{{ $t('shell.command.placeholder') }}</span>
      <span class="omx-top__cmd-kbd">{{ kbdHint }} K</span>
    </button>

    <div class="omx-top__actions">
      <button class="omx-top__action" v-if="loggedIn" @click="$emit('account')" :title="$t('top-menu.account')">
        <b-icon icon="account-cog" size="is-small" />
      </button>
      <button class="omx-top__action" v-if="loggedIn" @click="$emit('logout')" :title="$t('top-menu.sign-out')">
        <b-icon icon="logout" size="is-small" />
      </button>
    </div>
  </header>
</template>

<script>
import OmxBreadcrumbs from "./OmxBreadcrumbs.vue";

export default {
  name: "OmxTopbar",
  components: { OmxBreadcrumbs },
  props: {
    loggedIn: { type: Boolean, default: false }
  },
  computed: {
    kbdHint() {
      if (typeof navigator === 'undefined') return 'Ctrl';
      return /Mac|iPhone|iPad/.test(navigator.platform) ? '⌘' : 'Ctrl';
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.omx-top {
  height: $omx-shell-top-height;
  background: $omx-surface;
  border-bottom: 1px solid $omx-ink-100;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 22px;
  position: sticky;
  top: 0;
  z-index: 20;
}

.omx-top__burger {
  display: none;
  background: transparent;
  border: 1px solid $omx-ink-100;
  border-radius: 8px;
  width: 34px; height: 34px;
  color: $omx-ink-700;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  &:hover { background: $omx-ink-50; }
}

.omx-top__crumbs {
  flex-shrink: 0;
}

.omx-top__cmd {
  flex: 1;
  max-width: 480px;
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid $omx-ink-100;
  background: $omx-ink-50;
  border-radius: 999px;
  padding: 6px 14px;
  color: $omx-ink-500;
  font-size: 13px;
  cursor: pointer;
  font-family: inherit;
  transition: border-color .12s, background .12s;
  &:hover {
    border-color: $omx-brand-500;
    background: $omx-brand-50;
    color: $omx-brand-700;
  }
}
.omx-top__cmd-text {
  flex: 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.omx-top__cmd-kbd {
  font-family: $omx-font-mono;
  font-size: 11px;
  border: 1px solid $omx-ink-200;
  background: #fff;
  padding: 1px 6px;
  border-radius: 6px;
  color: $omx-ink-700;
  flex-shrink: 0;
}

.omx-top__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}
.omx-top__action {
  width: 34px; height: 34px;
  border-radius: 8px;
  border: 1px solid $omx-ink-100;
  background: $omx-surface;
  color: $omx-ink-700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:hover { border-color: $omx-brand-500; color: $omx-brand-600; }
}

@media (max-width: 900px) {
  .omx-top {
    padding: 0 14px;
    gap: 10px;
  }
  .omx-top__burger { display: inline-flex; }
  .omx-top__cmd-text { display: none; }
  .omx-top__cmd { padding: 6px 10px; }
  .omx-top__cmd-kbd { display: none; }
}
</style>
